<template>
  <div class="product">
    <div class="banner">
      <div>{{ $route.query.name }}</div>
    </div>
    <div class="product-content ">
      <div v-if="$route.query.id === '1'" class="one module">
        <div class="main">
          <div class="title">蓝牙便携式医废称重器</div>
          <div class="bd">
            <div class="img"><img src="../assets/image/page5/1-02.png" alt=""></div>
            <div class="text">
              <p>精确度：3级，n=3000</p>
              <p>显示：LCD液晶显示</p>
              <p>电源：3.7V1500mAh锂聚合物电池</p>
              <p>通讯接口：蓝牙4.0，与PDA，APP、小程序匹配</p>
              <p>称重范围：0-50KG</p>
              <p>尺寸：166X127X28.5mm</p>
              <p>环境支持：工作温度-10℃至40℃，存储温度-22℃至55℃</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="$route.query.id === '2'" class="one module">
        <div class="main">
          <div class="title">基于物联网的医废称重器</div>
          <div class="bd">
            <div class="img"><img src="../assets/image/page5/1-03.png" alt=""></div>
            <div class="text">
              <p>操作系统：安卓7.1</p>
              <p>屏幕尺寸：10.1寸电容屏，分辨率16：10</p>
              <p>容量：RAM(ROM) 2G+8G</p>
              <p>通讯传输：能支持4/3/2G、wifi、蓝牙功能</p>
              <p>秤盘：碳钢烤漆加不锈钢秤盘</p>
              <p>量程：大于等于1500kg</p>
              <p>精度：小于等于10g</p>
              <p>环境支持：工作温度-20℃至50℃，存储温度-30℃至60℃</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="$route.query.id === '3'" class="one module">
        <div class="main">
          <div class="title">危废称重一体化终端控制箱</div>
          <div class="bd">
            <div class="img"><img src="../assets/image/page5/1-04.png" alt=""></div>
            <div class="text">
              <p>适用场景：年产废量大于10吨企业</p>
              <p>防水防尘等级：IP65</p>
              <p>操作系统：安卓7.1</p>
              <p>屏幕尺寸：10.1寸电容屏，分辨率16：10</p>
              <p>容量：RAM(ROM) 2G+8G</p>
              <p>通讯传输：能支持4/3/2G、wifi、蓝牙功能</p>
              <p>打印机：内置热敏(碳带)打印机</p>
              <p>仪表：LCD液晶</p>
              <p>尺寸：W*H*D500X630X480mm</p>
              <p>外界设备：可绑定无线手持扫码枪</p>
              <p>环境支持：工作温度-20℃至50℃，存储温度-30℃至60℃</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="$route.query.id === '4'" class="one module">
        <div class="main">
          <div class="title">智能物联网电子磅秤</div>
          <div class="bd" style="align-items: center;">
            <div class="img"><img src="../assets/image/page5/1-05.png" alt=""></div>
            <div class="text">
              <p>准确度：3级,n=3000；</p>
              <p>采样速度：10次/秒 </p>
              <p>传感器灵敏度范围：1.5～3mV / V</p>
              <p>使用电源：免维护铅酸蓄电池 DC 6V/4AH；9V/300MA , DC电源</p>
              <p>通讯接口（可选）：RS232/RS485; </p>
              <p>波特率（可选）：1200/2400/4800/9600</p>
              <p>使用温度：0∽40℃，储运温度：-25~55℃</p>
              <p>湿度:≤85%RH。</p>
              <p>功能：选配RS232/RS485端口4G,WIFI等，可连接电脑或</p>
              <p>专用打印机，报警灯，U盘保存数据，APP,外接大屏幕和蓝牙</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="$route.query.id === '5'" class="one module">
        <div class="main">
          <div class="title">边缘计算智能分析盒子</div>
          <div class="bd" style="align-items: center;">
            <div class="img"><img src="../assets/image/page5/1-06.png" alt=""></div>
            <div class="text">
              <table cellspacing="0" cellpadding="0">
                <tr>
                  <td class="blue border1">产品型号</td>
                  <td class="blue">AIBOX-4</td>
                  <td class="blue">AIBOX-16</td>
                  <td class="blue">AIBOX-32</td>
                  <td class="blue">AIBOX-64</td>
                </tr>
                <tr>
                  <td border1>主控 CPU</td>
                  <td>RV1126</td>
                  <td>RK3588</td>
                  <td>RK3568</td>
                  <td>RK3568</td>
                </tr>
                <tr>
                  <td class="blue-light border1">操作系统</td>
                  <td class="blue-light" colspan="4">LINUX</td>
                </tr>
                <tr>	
                  <td class="border1">协处理器</td>
                  <td>Npu</td>
                  <td>Npu</td>
                  <td>Rv1126*8</td>
                  <td>Rv1126*16</td>
                </tr>		
                <tr>
                  <td class="blue-light border1">内存</td>
                  <td class="blue-light">2G</td>
                  <td class="blue-light">4G</td>
                  <td class="blue-light">12G</td>
                  <td class="blue-light">20G</td>
                </tr>
                <tr>
                  <td class="border1">Flash</td>
                  <td>8G</td>
                  <td>16G</td>
                  <td>80G</td>
                  <td>144G</td>
                </tr>
                <tr>
                  <td class="blue-light border1">算力</td>
                  <td class="blue-light">2Tops</td>
                  <td class="blue-light">6Tops</td>
                  <td class="blue-light">16Tops</td>
                  <td class="blue-light">32Tops</td>
                </tr>
                <tr>
                  <td class="border1">视频接入</td>
                  <td>4路1080P</td>
                  <td>16路1080P</td>
                  <td>32路1080P</td>
                  <td>64路1080P</td>
                </tr>
                <tr>
                  <td class="blue-light border1" rowspan="2">网络接口</td>
                  <td class="blue-light">1000Mbps*1</td>
                  <td class="blue-light" rowspan="2" colspan="3">1000Mbps*2 /4G/WIFI选配</td>
                </tr>
                <tr>
                  <td class="blue-light">4G/WIFI选配</td>
                </tr>
                <tr>
                  <td class="blue-light border1" rowspan="4">外部接口</td>
                  <td>RS232*1</td>
                  <td>RS232*1</td>
                  <td colspan="2">RS232*1</td>
                </tr>
                <tr>
                  <td>RS485*1</td>
                  <td>RS485*1</td>
                  <td colspan="2">RS485*1</td>
                </tr>
                <tr>
                  <td>USB*4</td>
                  <td>USB*4</td>
                  <td colspan="2">USB*4</td>
                </tr>
                <tr>
                  <td>HDMI*2</td>
                  <td>HDMI*3</td>
                  <td colspan="2">HDMI*1</td>
                </tr>
                		
                <tr>
                  <td class="blue-light border1">电源接口</td>
                  <td class="blue-light">DC12V 2A</td>
                  <td class="blue-light" colspan="3">DC 12V 5A</td>
                </tr>
                		
                <tr>
                  <td class="border1">工作温度</td>
                  <td>-20-55℃</td>
                  <td colspan="3">-20-70℃</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="ft scenario">
            <div class="name">
              <div class="value">应用场景</div>
              <div class="bg"></div>
            </div>

            <ul>
              <li>
                <div class="img-box">
                  <img src="../assets/image/page5/1-07.png" alt="">
                  
                </div>
                <div class="tit">可用于工厂安全生产监管场景中，如：化工厂、 烟花爆竹厂、重点危化企业等，实时监测人员 口罩佩戴、安全帽佩戴、危险区域闯入等</div>
              </li>
              <li>
                <div class="img-box">
                  <img src="../assets/image/page5/1-08.png" alt="">
                  
                </div>
                <div class="tit">可用于社区物业管理，例如小区周界防范、危险区域如供电房等是否有人员靠近等检测</div>
              </li>
              <li>
                <div class="img-box">
                  <img src="../assets/image/page5/1-09.png" alt="">
                  
                </div>
                <div class="tit">应用于工业园区、物流仓库等场所的周界安全 防范、检测是否佩戴口罩等防疫场景中</div>
              </li>
              <li>
                <div class="img-box">
                  <img src="../assets/image/page5/1-10.png" alt="">
                  
                </div>
                <div class="tit">适用于医疗、食品卫生、餐饮等场景的口罩佩戴识别</div>
              </li>
              <li>
                <div class="img-box">
                  <img src="../assets/image/page5/1-11.png" alt="">
                  
                </div>
                <div class="tit">可用于野外监控场景，如变电站，水利设施等， 防范可疑人员靠近、危险区域闯入、人员破坏、 偷盗等</div>
              </li>
              <li>
                <div class="img-box">
                  <img src="../assets/image/page5/1-12.png" alt="">
                  
                </div>
                <div class="tit">协助公共区域防疫工作的开展，实时监测区域 内人员是否佩戴口罩，并可结合语音装置发出提醒</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  data() {
    return {
      
    };
  },
  components: {
    Banner
  },

};
</script>

<style lang="scss" scoped>
.product {
  width: 100%;
  height: 100%;
  background-color: #f3f3f3;
  .banner{
    height: 380px;
    background: url(../assets/image/page5/banner-detail.jpg) no-repeat center;
    color: #fff;
    font-size: 45px;
    line-height: 380px;
    text-align: center;
  }
  .module{
    background: #fff;
    margin-bottom: 20px;
    padding: 40px 0 100px;
    .main{
      width: 1180px;
      margin: 0 auto;
    }
  }
  .one{
    
    .title{
      position: relative;
      font-size: 32px;
      padding-left: 40px;
      color: #3087d6;
      margin-bottom: 118px;
      &::before{
        position: absolute;
        left: 0; 
        top: 12px;
        content: ' ';
        display: block;
        width: 20px;
        height: 20px;
        transform: rotate(45deg);
        background: #3087d6;
      }
    }
    .bd{
      display: flex;
      justify-content: space-between;
      .img{
        width: 585px;
        text-align: right;
      }
      .text{
        width: 480px;
        font-size: 18px;
        p{
          padding-left: 6px;
          line-height: 40px;
          &:nth-child(2n){
            background: #d7e7f7;
          }
        }
      }
      .blue{
        background: #5092de;
        color: #fff;
      }
      .blue-light{
        background: #d7e7f7;
      }
      table{
        text-align: center;
        font-size: 14px;
        border-collapse:collapse;
        td{
          width: 130px;
          height: 30px;
          border-right: 8px #fff solid;
        }
        td.border1{
          border-right-width: 1px;
        }
      }
    }
    .scenario{
      width: 1350px;
      margin-left: -85px;
      margin-top: 20px;
      .name{
        position: relative;
        width: 82px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        margin-bottom: 57px;
        .value{
          position: absolute;
          left: 0;
          top: 0;
          z-index: 3;
          width: 82px;
          height: 30px;
          background: #5092dc;
          color: #fff;
          font-size: 16px;
        }
        .bg{
          position: absolute;
          left: 5px;
          top: 5px;
          z-index: 2;
          width: 82px;
          height: 30px;
          background: #ffbe68;
        }
      }
      ul{
        display: flex;
        justify-content: space-between;
        li{
          width: 200px;
          list-style: none;
          .img-box{
            width: 100%;
            height: 129px;
            img{
              width: 100%;
            }
          }
          .tit{
            font-size: 14px;
            color: #000;
          }
        }
      }
    }
    
  }
}




</style>